export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);
export const mapLinks = (links) => links.map(({ name, url }) => ({
    name,
    url,
}));
export const isStringInArrayCaseInsensitive = (array, string) => !!array.find((item) => item.toLowerCase() === string.toLowerCase());
//# sourceMappingURL=utils.js.map